.radioSubItemWrapper {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-left: 1px;

	& .description:global(.MuiTypography-root) {
		color: #525252;
		font-size: 0.875rem;
		line-height: 20px;
		font-weight: 400;
	}
}

.checkboxSubItemWrapper {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 0.3125rem;

	& .textWrapper {
		gap: 0.3125rem;
		align-items: center;
		display: flex;
		flex-direction: row;
	}

	& .badgeContainer {
		display: inline-flex;
		margin-left: 0.3125rem;
		gap: 0.3125rem;
	}

	& .checkboxLabel {
		color: #525252;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 20px;
		cursor: pointer;
		margin-top: 0.1rem;
	}

	/* Sub-option labels lead with a bolded title, followed by the description in the same label. */
	& .checkboxLabel strong {
		color: #262626;
		font-weight: 500;
	}

	& .formColWrapper {
		display: flex;
		flex-direction: column;
		gap: 0.625rem;
		justify-content: center;
		height: 100%;
	}
}
